import { Route } from '@angular/router';

export interface AdminNavigationEntry {
	path: string;
	label: string;
	description: string;
}

export const ADMIN_NAVIGATION_ENTRIES: AdminNavigationEntry[] = [
	{
		path: '/admin/translations',
		label: 'Translations',
		description: 'Review and maintain localized content across the platform.',
	},
	{
		path: '/admin/emails',
		label: 'Emails',
		description: 'Review recent outgoing emails, inspect delivery attempts, and resend them.',
	},
	{
		path: '/admin/tasks',
		label: 'Tasks',
		description: 'Inspect background jobs, processing progress, and retry failed work.',
	},
	{
		path: '/admin/users',
		label: 'Users',
		description: 'Manage users and apply account-level admin actions.',
	},
	{
		path: '/admin/tickets',
		label: 'Articles and tickets',
		description: 'Review public content, support and backlog conversations, visibility, and messages.',
	},
	{
		path: '/admin/feedback',
		label: 'Feedback',
		description: 'View all embedded feedback widgets responses and analyze results.',
	},
	{
		path: '/admin/cronjobs',
		label: 'Cron Jobs',
		description: 'View, add, remove, and manually run scheduled cron jobs. Inspect last run output and log files.',
	},
	{
		path: '/admin/assistant-tools',
		label: 'Assistant tools',
		description: 'Inspect the tools available to the assistant background task via the MCP server.',
	},
];

export function extractAdditionalAdminNavigationEntries(adminRouteConfig: Route | null | undefined): AdminNavigationEntry[] {
	return (adminRouteConfig?.children ?? [])
		.filter((route) => typeof route.data?.['adminNavigationLabel'] === 'string' && typeof route.path === 'string')
		.map((route) => ({
			path: `/admin/${route.path}`,
			label: route.data?.['adminNavigationLabel'],
			description: 'Application-specific admin tool.',
		}));
}
